import React from "react";

const InstallationStatus = ({ items, status }) => {
  return (
    <div style={{ padding: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h2
          style={{
            fontSize: "15px",
            fontWeight: 500,
            color: "#18242D",
            margin: 0,
          }}
        >
          Installation Status
        </h2>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            fontSize: "13px",
            fontWeight: 400,
            color: "#18242D",
            padding: "4px 8px",
            backgroundColor: "#DBDDF1",
            borderRadius: "7px",
            width: "fit-content",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: status?.style?.color,
              display: "inline-block",
            }}
          ></span>
          {status?.children}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          backgroundColor: "#FFFFFF",
          borderRadius: "0.375rem",
          padding: "1rem",
          gap: "1rem",
          justifyContent: "space-between",
        }}
      >
        {items.map((it) => (
          <div key={it.label} style={{ textAlign: "center", flex: 1 }}>
            <div
              style={{
                fontSize: "13px",
                fontWeight: 400,
                color: "#18242D",
                marginBottom: "0.25rem",
              }}
            >
              {it.label}
            </div>
            <div
              style={{
                fontSize: "14px",
                fontWeight: 550,
                color: "#18242D",
              }}
            >
              {it.value}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstallationStatus;
